import type { ViewName } from "../api/types";

/** Calendar views: label and keyboard shortcut, in the order the view switcher shows them. */
export const VIEW_LABELS: Record<ViewName, { label: string; key: string }> = {
  day: { label: "Dia", key: "D" },
  "4days": { label: "4 dias", key: "X" },
  week: { label: "Semana", key: "W" },
  month: { label: "Mês", key: "M" },
  year: { label: "Ano", key: "Y" },
  schedule: { label: "Lista", key: "A" }
};

export const VIEW_ORDER = Object.keys(VIEW_LABELS) as ViewName[];
